import { render, staticRenderFns } from "./ContractRemindComponent.vue?vue&type=template&id=6703d3c3"
import script from "./ContractRemindComponent.vue?vue&type=script&lang=js"
export * from "./ContractRemindComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports